<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import moment from 'moment-timezone'

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

export default {
  name: "AuditLog",
  components: {
    Pagination,
    ErrorComponent,
    CustomerDateRangePicker
  },
  data() {
    return {
      item: {},
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: "",
        reference_type: "",
        employee_id: "",
        to_date: "",
        from_date: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }
      this.filterObj.created_at__gte = moment(String(this.date.startDate)).startOf('day').toISOString()
      this.filterObj.created_at__lte = moment(String(this.date.endDate)).endOf('day').toISOString();
      this.$api
        .getAPI({
          _action:
            `/audit-log/?offset=${(page-1)*this.itemsPerPage}&limit=${this.itemsPerPage}`,
          _body: this.filterObj
        })
        .then(res => {
          res.list = res.results
          if (res.list != null && res.list.length > 0) {
            this.list = res.results;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_audit_log_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    view(item) {
      this.item = item;
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    details(type, id) {
      if (type == "LOST" || type == "DAMAGE") {
        router.push("/view-stock-adjustment/" + id);
      }
      if (type == "TRANSFERRED") {
        router.push("/view-transfer-order/" + id);
      }

      if (type == "RECEIVED") {
        router.push("/view-purchase-order/" + id);
      }

      if (type == "RETURNED" || type == "SOLD") {
        router.push("/sales_receipts");
      }

      if (type == "RECOUNTED") {
        router.push("/view-inventory-count/" + id);
      }

      if (type == "PRODUCTION") {
        router.push("/view-production/" + id);
      }
    },
    getExport() {
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }

      this.$api.getAndDownloadAPI({ _action: "/inventory_count/export_inventory_history/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'audit_log.csv'})
    },
    dateTimezone(date){
      let timezone = localStorage.getItem("timezone") || '{"value": "+7"}';
      timezone = JSON.parse(timezone)
      let value = timezone.value
      value = parseFloat(value.replace('+', '').replace(':', '.'))
      return moment.tz(date, "UTC").add(value, 'hours').format('DD-MM-YYYY HH:mm:ss');
    },
    storesAudit(storeBefore, storeAfter){
      let arr = this.$_.map(storeBefore, 'name').concat(this.$_.map(storeAfter, 'name'))
      arr = [...new Set(arr)]
      arr.sort()
      return arr.join(', ')
    }
  },
  mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 mllg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>

            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 mllg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select class="form-control" v-model="filterObj.reference_type" @change="getList(1)">
                <option value>{{$lang.messages.all_objects}}</option>
                <option value="ITEM">{{$lang.messages.item}}</option>
                <option value="ITEM_INVENTORY">{{$lang.messages.item_inventory}}</option>
                <option value="CATEGORY">{{$lang.messages.category}}</option>
                <option value="EMPLOYEE">{{$lang.messages.employee}}</option>
                <option value="DISCOUNT">{{$lang.messages.discount}}</option>
                <option value="ACCESS_RIGHT">{{$lang.messages.access_rights}}</option>
                <option value="CUSTOMER">{{$lang.messages.customer}}</option>
                <option value="RECEIPT">{{$lang.messages.receipt}}</option>
                <option value="GENERAL_SETTING">{{$lang.messages.general_settings}}</option>
                <option value="ACCOUNT_INFO">{{$lang.messages.account_information}}</option>
                <option value="BANK_INFO">{{$lang.messages.bank_information}}</option>
                <option value="STORE">{{$lang.messages.store}}</option>
                <option value="PAYMENT">{{$lang.messages.payment_type}}</option>
                <option value="DELIVERY_TYPE">{{$lang.messages.dinning_options}}</option>
                <option value="DELIVERY_STORE">{{$lang.messages.dinning_options_store}}</option>
                <option value="DELIVERY_STORE">{{$lang.messages.personal_information}}</option>
              </select>
            </div>


            <button
              type="button"
              class="btn bg-white search-box border-secondary rounded-5 mr-3 mr-lg-3 mr-md-0 mb-lg-0 mb-3"
              style="height: 42px">
              <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                <i class="fas fa-search font-16"></i>
              </a>
              <form class="app-search position-absolute" v-on:submit.prevent>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterObj.search"
                  :placeholder="$lang.messages.search_enter"
                  v-on:keyup.enter="getList(1)"/>
                <a class="srh-btn">
                  <i class="ti-close"></i>
                </a>
              </form>
            </button>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="bg-white mt-3"></div>
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">{{$lang.messages.date}}</th>
                      <th scope="col">{{$lang.messages.employee}}</th>
                      <th scope="col">{{$lang.messages.store}}</th>
                      <th scope="col">{{$lang.messages.object}}</th>
                      <th scope="col">{{$lang.messages.object_name}}</th>
                      <th scope="col">{{$lang.messages.action}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.before_changes}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.after_changes}}</th>
                    </tr>
                  </thead>

                  <template v-for="(item, i) in list">
                    <tbody
                        :key="i"
                        data-target="#AuditLogDetail"
                        class="clickable-row"
                        data-toggle="modal"
                        @click="view(item)"
                    >
                      <tr>
                        <td>{{ dateTimezone(item.created_at) }}</td>
                        <td>{{item.user.name}}</td>
                        <td>
                            <div>
<!--                            <div v-if="!!item.stores_after">-->
<!--                              {{$_.map(item.stores_after, 'name').join(', ')}}-->
<!--                            </div>-->
<!--                            <div v-else-if="!!item.stores_before">-->
<!--                              {{$_.map(item.stores_before, 'name').join(', ')}}-->
<!--                            </div>-->
                            {{storesAudit(item.stores_after, item.stores_before)}}
                            </div>
                        </td>
                        <td>{{item.log_type}}</td>
                        <td>
                            <div>
                            <div v-if="item.after && item.after.name">
                              {{item.after.name}}
                            </div>
                            <div v-else-if="!!item.before && item.before.name">
                              {{item.before.name}}
                            </div>
                            <div v-else>
                              -
                            </div>
                          </div>
                        </td>
                        <td>{{item.log_status}}</td>
                        <td><div>{{item.str_before}}</div></td>
                        <td><div>{{item.str_after}}</div></td>
                      </tr>
                    </tbody>
                  </template>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>
            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal right fade"
      id="AuditLogDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document" style="max-width: 800px !important;">
        <div class="modal-content">
          <div class="modal-header d-block text-center" style="border-bottom: none">
            <h4 class="modal-title f-semi-bold font-16" id="myModalLabel2">
              {{$lang.messages.changes_detail}}
            </h4>
          </div>

          <div class="modal-body">
            <div class="card" style="margin-top: 20px">
              <div class="card-body px-0 pt-0">
                <div class="table-responsive">
                  <table class="table table-style-1  mt-0 table-bordered" id="table-audit-log-detail">
                    <thead>
                      <tr>
                        <th scope="col" style="text-align: left">{{$lang.messages.field}}</th>
                        <th scope="col">{{$lang.messages.before_changes}}</th>
                        <th scope="col">{{$lang.messages.after_changes}}</th>
                      </tr>
                    </thead>

                    <tbody>
                        <tr v-if="!!item.stores_diff && item.stores_diff.length > 0 && (!!item.stores_before || !!item.stores_after)">
                          <td>{{ $lang.messages.stores }}</td>
                          <td v-if="!!item.stores_before" style="border-left: none">{{$_.map(item.stores_before, 'name').join(', ') }}</td>
                          <td v-else>-</td>
                          <td v-if="!!item.stores_after" style="border-left: none">{{$_.map(item.stores_after, 'name').join(', ') }}</td>
                          <td v-else>-</td>
                        </tr>

                        <template v-if="!!item.diff && !!item.diff.length > 0 ">
                          <template v-for="(diff, i) in item.diff">
                            <template v-if="diff[0] == 'add'">
                              <template v-for="(item, ii) in diff[2]">
                                <tr v-if="item[1] !== '' && item[0] != 'status' ">
                                  <td>{{ item[0] | bool2StringFormat }}</td>
                                  <td>-</td>
                                  <td>{{item[1] | bool2StringFormat}}</td>
                                </tr>
                              </template>
                            </template>

                            <template v-if="diff[0] == 'remove'">
                                <template v-for="(item, ii) in diff[2]">
                                  <tr v-if="item[1] !== '' && item[0] != 'status'">
                                    <td>{{ (item[0] !== '' ? item[0] : '-') | bool2StringFormat }}</td>
                                    <td>{{ (item[1] !== '' ? item[1] : '-') | bool2StringFormat }}</td>
                                    <td>-</td>
                                  </tr>
                                </template>
                            </template>

                            <template v-if="diff[0] == 'change'">
                                <tr v-if="diff[1] != 'status' ">
                                  <td>{{ diff[1] }}</td>
                                  <td>{{ (diff[2][0] !== '' ? diff[2][0] : '-') | bool2StringFormat }}</td>
                                  <td>{{ (diff[2][1] !== '' ? diff[2][1] : '-') | bool2StringFormat }}</td>
                                </tr>
                            </template>

                          </template>
                        </template>
                    </tbody>

                  </table>
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>


<style>
  #table-audit-log-detail > tbody > tr > td,
  #table-audit-log-detail > thead > tr > td,
  #table-audit-log-detail {
      border-bottom: 0;
      border-top: 0;
  }

  table > tbody > tr > td:nth-child(3) > div,
  table > tbody > tr > td:nth-child(7) > div,
  table > tbody > tr > td:nth-child(8) > div{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
  }

  #AuditLogDetail tr td{
    white-space: pre-line;
  }
</style>
